import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** @see docs/API_SYSTEM_ACCESS.md */
export async function fetchUserAccess(userId) {
  const { data: raw } = await request.get(`/system/user/${userId}/access`);
  return parseVer4DetailResponse(raw);
}
